import { APP_VERSION, COUNTRY_CODE, EnvironmentType } from "./environment.type";

export const environment: EnvironmentType = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Sao_Paulo",
  code: COUNTRY_CODE.br,
  currency: "BRL",
  grammar: "pt-BR",
  lang: "pt",
  phone_length: 10,
  max_phone_length: 11,
  max_tip: 0,
  phone_prefix: "+55",
  gateway: {
    base_url: "https://services.rappi.com.br",
    location_gateway_prefix: "/api/cargo-api-gateway/core-maps/address/",
    csv_prefix: "/api/cargo-api-gateway/csv/portal/",
    gateway_prefix: "/api/cargo-api-gateway/portal/",
    settlement_prefix: "/api/cargo-api-gateway/portal/settlement/",
    cashless_prefix: "/api/ms/cargo-cashless/",
    maps_prefix: "/api/maps/v1/",
  },
  logoUrl: "https://cargo-core-api.s3.us-west-2.amazonaws.com/br/cargo-logos/",
  trackingUrl: "cargo-tracking.rappi.com.br/",
  aws_location: {
    api_key:
      "v1.public.eyJqdGkiOiJmMGU4ZWMyZS1kMzhiLTQzNmUtYTA2Yi03ZWI0YmM3MDcwOGQifSmzK9yVhT0NyPzA2qdHNZyIQGFnROhcdGcSZoMyJKXQTtBdvOkRSMzu6HMynuXDFdXnhnBWrvhzREUgruuQEqGy5KeUSVeL2dW_WBcBC-QypNdhqSo7U70Q4N4cTBbQWWzdljYUYIvPRC2W05J3-oX_lNbFylLIHh0dGwu6UZ1H6TeH-SDCC0Bqoxc-dBzM5_OAps6eoPoKHk9egOqH403JecfB94FtH57X5wTJYAD2hHG8nkosLYOtELCShzJIHef5trlnqXrYajEYOq0Eoa05e4Ka51nFypsK2LDPpVYh4teZfHGOD-9t9kydc0h-BNxs6uFrTmQphIiFUcHju40.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx",
    region: "us-east-1",
    style: "Standard",
    color_scheme: "Light",
  },
  coordsCenter: { lat: -15.77972, lng: -47.92972 },
  currencySymbol: "R$",
  decimalPattern: /^[0-9]+([.]\d{0,1})?$/,
  decimalNumber: 2,
  country: {
    defaultLocale: "pt-BR",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/br/cargo-logos/",
  auth0: {
    client_id: "hDcAOaY9heMYiAxYPvr5Ynt3ZeNybA43",
    client_secret: "OxnMGuC8OXHjYTgznaaKL2ItdOB4xdMj2jpTDbx6au00NQX47lBEdjgGXc6ia2m4",
    domain: "https://login.partners.rappi.com",
  },
  amplitude: {
    key: "032f00f0dfdad881e7391f28f35156f6",
  },
  i18n_version: APP_VERSION,
  kustomer_assistant_id: "664bbe3419e7a2316b52dc7a",
  recaptcha_site_key: "6Le98o0sAAAAAMT-KoXGJs6OW-aYF9sbNdbigJaR",
  amazon_connect: {
    snippet_id:
      "QVFJREFIaGRXUHpDQ0syTWozT3FtUTlKL1lZeW8zbzdUZEQ4Y1A3d0wzMWFuQ0RFM0FIUjdSZEdzTzJWYWV1Ynl4NjY4QmRCQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNWXRNZ0JBWUpaUHM2NkhSSkFnRVFnQ3NiNFdUQ0xxSVVDVXBTRldTQzlGU0xSanRhYTFXWm5kMG85RWRBNnB6TDV0bnFRRnQ4V1JlVVhDVGg6OmNGZ0IwVjVrUEhIWlIwNDAyN0ZTTmtMcUpseTYvVlI0enFiSkpCWTVDazQxV3BlTmlKN2V6VDUyblpDYmswMjRlS3NIQnlWN2ZiN3NTNmN3UHBFdjczbGVWRDhkMDlBb25sTGgxUVlGcStIcC9wSVlISDhSa2orSjdDQVIwaEJTZEdNQWJML2g1OXIrZ1RNUWhReXFOSTNDS3puS2RRUT0=",
    src: "https://connect-rappi-support-prod.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js",
    script_id: "37223493-6644-445d-bae1-7074a64d629c",
  },
};
